"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogResource = void 0;
class CatalogResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /* --- Categories --- */
    listCategories(query) {
        return this.http.get('categories', { query });
    }
    createCategory(payload) {
        return this.http.post('categories', payload);
    }
    updateCategory(id, payload) {
        return this.http.patch(`categories/${id}`, payload);
    }
    deleteCategory(id) {
        return this.http.delete(`categories/${id}`);
    }
    reorderCategories(ids) {
        return this.http.post('categories/reorder', { ids });
    }
    /* --- Products --- */
    listProducts(query) {
        return this.http.getPaginated('products', { query });
    }
    getProduct(id) {
        return this.http.get(`products/${id}`);
    }
    createProduct(payload) {
        return this.http.post('products', payload);
    }
    updateProduct(id, payload) {
        return this.http.patch(`products/${id}`, payload);
    }
    deleteProduct(id) {
        return this.http.delete(`products/${id}`);
    }
    /** Stop-list toggle the floor staff uses when something runs out. */
    setAvailability(productId, payload) {
        return this.http.patch(`products/${productId}/availability`, payload);
    }
    /** Uploads a product image; returns the stored URL to put on the product. */
    uploadImage(file, fileName = 'image.jpg') {
        const form = new FormData();
        form.append('file', file, fileName);
        return this.http.upload('files/images', form);
    }
    /* --- Modifiers --- */
    listModifierGroups() {
        return this.http.get('modifier-groups');
    }
    createModifierGroup(payload) {
        return this.http.post('modifier-groups', payload);
    }
    updateModifierGroup(id, payload) {
        return this.http.patch(`modifier-groups/${id}`, payload);
    }
    deleteModifierGroup(id) {
        return this.http.delete(`modifier-groups/${id}`);
    }
    /**
     * The full menu for one branch, availability already applied.
     * Guests resolve the tenant by slug; staff sessions retain their JWT scope.
     */
    branchMenu(branchId) {
        // Public guests use the slug; signed-in tills use their verified JWT.
        return this.http.get(`menu/${branchId}`);
    }
}
exports.CatalogResource = CatalogResource;
//# sourceMappingURL=catalog.js.map